/**
 * 基础数据处理 用于表格的加载和删除
 * 表格的加载和删除用同一个接口 不同的请求方式
 */
import {METHOD, request} from '@/utils/request'

export async function list(url, params) {
	return request(url, METHOD.GET, params)
}

export async function delList(url, params) {
	return request(url, METHOD.DELETE, params)
}

/**
 * 树列表 树一次性将所有节点返回
 * @param url
 * @param params
 * @return {Promise}
 */
export async function treeList(url, params) {
	return request(url, METHOD.GET, params)
}

/**
 * 删除树节点 一次只能删除一个
 * @param url
 * @param keyId
 * @return {Promise}
 */
export async function delTreeList(url, keyId) {
	return request(url + "/" + keyId, METHOD.DELETE)
}

export default {list, delList, treeList, delTreeList}